import React from 'react';
import { useAuthV2 } from '../../context/auth-v2/AuthContext';
import { BUSINESS_ROLE_PERMISSIONS } from '../../types/roles';
import type { BusinessRole } from '../../types/roles';
import { useNavigate } from 'react-router-dom';
import { ArrowLeftIcon } from '@heroicons/react/24/solid';
import DevStaffManagement from '@/components/dev/DevStaffManagement';
import { isDevEnvironment } from '@/utils/environment';

const BusinessUsers: React.FC = () => {
  const { user: currentStaff } = useAuthV2();
  const role = (currentStaff?.role || 'staff') as BusinessRole;
  const permissions = BUSINESS_ROLE_PERMISSIONS[role];
  const navigate = useNavigate();
  const isDevelopment = isDevEnvironment();

  // In development mode, always allow access to staff management
  if (!permissions.canManageStaff && !isDevelopment) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-4xl mx-auto p-6">
          <div className="space-y-6">
            <div className="flex items-center">
              <button
                onClick={() => navigate('/business/dashboard')}
                className="mr-4 flex items-center text-gray-600 hover:text-gray-900"
              >
                <ArrowLeftIcon className="h-5 w-5 mr-1" />
                Back
              </button>
              <h1 className="text-2xl font-bold text-gray-900">Staff Management</h1>
            </div>
            <div className="bg-white p-6 rounded-lg shadow">
              <p className="text-center text-gray-600">You do not have permission to manage staff members.</p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-4xl mx-auto p-6">
        <div className="space-y-6">
          <div className="flex items-center">
            <button
              onClick={() => navigate('/business/dashboard')}
              className="mr-4 flex items-center text-gray-600 hover:text-gray-900"
            >
              <ArrowLeftIcon className="h-5 w-5 mr-1" />
              Back
            </button>
            <h1 className="text-2xl font-bold text-gray-900">Staff Management</h1>
          </div>
          <DevStaffManagement orgType="business" />
        </div>
      </div>
    </div>
  );
};

export default BusinessUsers;